import { PosIconProps, SvgWrapper } from 'src/svgs/SvgWrapper';

export function SigninIcon(props: PosIconProps) {
  return (
    <SvgWrapper viewBox="0 0 14 16" fill="currentColor" {...props}>
      <path d="M10.571 8q0 .232-.17.402l-4.857 4.857q-.17.17-.402.17t-.402-.17-.17-.402v-2.571h-4q-.232 0-.402-.17t-.17-.402V6.285q0-.232.17-.402t.402-.17h4V3.142q0-.232.17-.402t.402-.17.402.17l4.857 4.857q.17.17.17.402zm3.143-3.143v6.286q0 1.063-.754 1.817t-1.817.754H8.286q-.116 0-.201-.085T8 13.428q0-.036-.009-.179t-.004-.237.027-.21.089-.174.183-.058h2.857q.589 0 1.009-.42t.42-1.009V4.855q0-.589-.42-1.009t-1.009-.42H8.357l-.103-.009-.103-.027-.071-.049-.063-.08-.018-.121q0-.036-.009-.179t-.004-.237.027-.21.089-.174.183-.058h2.857q1.063 0 1.817.754t.754 1.817z" />
    </SvgWrapper>
  );
}
